import {
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  ViewChild,
  signal,
  inject,
  effect,
  HostListener,
  untracked,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AddStockDialogComponent } from "./stock-dialog/stock-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { DataService } from "../data.service";
import "lodash";
declare var _: any;
import * as _latinize from "latinize";
const latinize = _latinize;
import * as _moment from "moment";
const moment = _moment;

import { ConfirmationDialogComponent } from "../shared/confirmation-dialog/confirmation-dialog.component";
import { AuthService } from "../auth.service";
import { db, qService } from "src/app/db.service";
import { liveQuery } from "dexie";
import {
  from,
  Observable,
  map,
  of,
  Subject,
  switchMap,
  defer,
  merge,
  tap,
  takeUntil,
  BehaviorSubject,
  combineLatest,
  distinctUntilChanged,
} from "rxjs";
import { ToastrService } from "ngx-toastr";
import { NewMaterialDialogComponent } from "../dialogs/material-dialog/material-dialog.component";
import { ColumnState, GridApi, GridReadyEvent } from "ag-grid-community";
import { slideAnimation, toggleWrap } from "../shared/fade.animation";
import { PusherService } from "../pusher.service";
import { StockTransferComponent } from "../dialogs/stock-transfer/stock-transfer.component";
import { StockService } from "./stock.service";
import { SyncService } from "../sync.service";
import { Router } from "@angular/router";
import { ReconciliationDialogComponent } from "../dialogs/reconciliation-dialog/reconciliation-dialog.component";

@Component({
  selector: "app-stock",
  templateUrl: "./stock.component.html",
  styleUrls: ["./stock.component.css"],
  animations: [slideAnimation, toggleWrap],
})
export class StockComponent implements OnInit, OnDestroy {
  _stockService = inject(StockService);
  _syncService = inject(SyncService);
  router = inject(Router);
  @ViewChild("navbar") navbar: ElementRef;
  @ViewChild("card") card: ElementRef;
  @ViewChild("cardsContainer") cardsContainer: ElementRef;
  @HostListener("window:keyup", ["$event"])
  keyEvent(event: KeyboardEvent) {
    if (event.key == "Escape") {
      this._dataService.showContextMenu = false;
    }
  }
  groupSumData = [];
  materials = localStorage.hasOwnProperty("materials")
    ? JSON.parse(localStorage.getItem("materials"))
    : [];
  request: any = null;
  showSummary: boolean = localStorage.hasOwnProperty(
    this._dataService.dbTable + "showStockSummary"
  )
    ? this._dataService.getLS("showStockSummary")
    : true;
  showStockInPrice: boolean = true;

  isWrapped: boolean = false;

  // NEW
  @ViewChild("searchInput") searchInput: ElementRef;
  dataLoading = signal(true);
  selectedStockGroupId = this._dataService.getLS("selectedStockGroupId")
    ? signal(this._dataService.getLS("selectedStockGroupId"))
    : signal(this._dataService.stockGroups().find((s) => s.type == 1)?.id || 1);
  protected _selectedStockGroupId$ = new BehaviorSubject(
    this.selectedStockGroupId()
  );

  dateNow = moment(Date.now()).format("YYYY-MM-DD");
  totalIn = this._dataService.getLS("stockTotalIn") || 0;
  totalOut = this._dataService.getLS("stockTotalOut") || 0;
  totalRemaining = this._dataService.getLS("stockTotalRemaining") || 0;

  performance: number = 0;

  protected gridApi!: GridApi;

  dbUpdated: boolean = false;
  _dbUpdating$ = new BehaviorSubject(true);

  navButtons = [
    {
      name: "Anbar Girişi",
      icon: "add",
      function: () => this.openAddStockDialog(null, "Stock Entry"),
      canAccess: true,
    },
    {
      name: "Anbar Çıxış",
      icon: "remove",
      function: () => this.openAddStockDialog(null, "Stock Out"),
      canAccess: true,
    },
    {
      name: "Köçürmə",
      icon: "move_down",
      function: () => this.openStockTransferDialog(),
      canAccess:
        this._authService.loggedInUserValue.role == 1 ||
        this._authService.loggedInUserValue.role == 2
          ? true
          : false,
    },
    {
      name: "Üzləşmə",
      icon: "move_down",
      function: () => this.openReconTransferDialog(),
      canAccess:
        this._authService.loggedInUserValue.role == 1 ||
        this._authService.loggedInUserValue.role == 2
          ? true
          : false,
    },
  ];

  navExtraButtons = [
    {
      name: "Anbar Qalığı",
      icon: "inventory",
      function: () => this.router.navigate(["./Materials"]),
      canAccess: this._authService.loggedInUserValue.role == 1 ? true : false,
    },
  ];

  ngHeader = {
    items: this._dataService.stockGroups(),
    selectedItem: this.selectedStockGroupId(),
  };

  columnDefs = [
    {
      headerName: "id",
      field: "tId",
      hide: true,
    },
    {
      headerName: "",
      field: "tType",
      maxWidth: 50,
      cellRenderer: (params) => {
        if (params.data.syncStatus == "pending") {
          return `<span class="material-symbols-outlined" style="font-size: 18px;">
          cloud_sync
          </span>`;
        }
        switch (params.value) {
          case "Stock Entry":
            return '<span class="material-symbols-outlined">place_item</span>';
          case "Stock Out":
            return '<span class="material-symbols-outlined">move_item</span>';
          case "Stock Transfer":
            return '<span class="material-symbols-outlined">component_exchange</span>';
          case "Reconciliation":
            return '<span class="material-symbols-outlined">fact_check</span>';
          default:
            "Anbar";
        }
      },
      cellClass: (params) => {
        switch (params.value) {
          case "Stock Entry":
            return "entryType stockEntry";
          case "Stock Out":
            return "entryType stockOut";
          case "Stock Transfer":
            return "entryType stockTransfer";
          case "Reconciliation":
            return "entryType reconciliation";
          default:
            return "entryType";
        }
      },
    },
    {
      headerName: "Material",
      field: "materialName",
      flex: 3,
      minWidth: 100,
      filterValueGetter: (params) =>
        this._dataService.latinizeText(params, "materialName"),
      cellClass: () => "justify-content-start",
      cellRenderer: (params) => {
        let res = params.data.refersTo
          ? `${params.value}<span>R</span>`
          : params.value;
        return res;
      },
    },
    {
      headerName: "Miqdar",
      field: "quantity",
      sortable: true,
      flex: 2,
      minWidth: 120,
      cellClass: (params) => {
        return params.value < 0 ? "minusValueRedColor" : "";
      },
      cellRenderer: (params) =>
        params.value
          ? params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
          : "*",
      cellStyle: { "word-spacing": "-2px !important", "white-space": "nowrap" },
    },
    {
      headerName: "Qiymət",
      field: "price",
      sortable: true,
      flex: 2,
      minWidth: 120,
      cellRenderer: (params) =>
        params.value
          ? params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
          : "*",
      cellStyle: { "word-spacing": "-2px !important", "white-space": "nowrap" },
    },
    {
      headerName: "Toplam",
      field: "sum",
      sortable: true,
      flex: 2,
      minWidth: 120,
      cellClass: (params) => {
        return params.value < 0 ? "minusValueRedColor" : "";
      },
      cellRenderer: (params) =>
        params.value
          ? this._dataService
              .formatNumber(params.value)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
          : "*",
      cellStyle: { "word-spacing": "-2px !important", "white-space": "nowrap" },
    },
    {
      headerName: "Tərəf Müqabil",
      field: "customerName",
      sortable: true,
      flex: 2,
      minWidth: 150,
      filterValueGetter: (params) =>
        this._dataService.latinizeText(params, "customerName"),
    },
    {
      headerName: "Tarix",
      field: "date",
      flex: 2,
      minWidth: 120,
      sortable: true,
      comparator: (dateA, dateB, nodeA, nodeB, isInverted) => {
        if (dateA === dateB) {
          // If dates are equal, sort by id (descending)
          const idA = nodeA.data.id;
          const idB = nodeB.data.id;
          return idA > idB ? -1 : idA < idB ? 1 : 0;
        } else {
          // Sort by date (descending)
          return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
        }
      },
      cellRenderer: (params) => {
        return params.value.split("-").reverse().join("-");
      },
    },
    {
      headerName: "Məlumat",
      field: "details",
      flex: 2,
      minWidth: 100,
    },
    {
      headerName: "",
      field: "delete",
      flex: 1,
      maxWidth: 50,
      cellRenderer: () => {
        return `<span class='d-flex align-items-center h-100'><i class='material-icons'>more_horiz</i></span>`;
      },
      onCellClicked: (params) => {
        this.contextMenu(params);
      },
    },
  ];

  agGridData$: Observable<any[]>;
  componentDestroyed$: Subject<boolean> = new Subject();

  contextMenuData = { x: 0, y: 0, data: null };
  hoverData;

  stockGraphsUnfiltered: {}[] = this._dataService.getLS("stocksSumData") || [];
  stockGraphs: {}[] = this._dataService.getLS("stocksSumData") || [];
  showTotal: boolean = false;
  summariesInKg: boolean = this._dataService.getLS("showStockSummariesInKG")
    ? this._dataService.getLS("showStockSummariesInKG")
    : false;

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    public _dataService: DataService,
    public _authService: AuthService,
    private toastr: ToastrService,
    private _pusher: PusherService
  ) {
    effect(async () => {
      this._dataService.materials();
      this._dataService.customers();
      this.agGridData$ = this.getStockTableData();
      this._dataService.dbChanged();

      // Sync with StockService to ensure Dashboard sees the same selection
      const groupId = this.selectedStockGroupId();
      if (groupId) {
        untracked(() => {
          this._stockService.selectedStockGroupId.set(groupId);
          this._stockService._selectedStockGroupId$.next(groupId);
        });
      }
    });
  }

  async ngOnInit() {
    this.navButtons = this.navButtons.filter((button) => button.canAccess);
    this.navExtraButtons = this.navExtraButtons.filter(
      (button) => button.canAccess
    );

    this.agGridData$ = this.getStockTableData();
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  // Optimized version with performance improvements and reduced redundancy

  // Cache maps at class level to avoid recreation
  private customersMapCache: Map<any, any> | null = null;
  private materialsMapCache: Map<any, any> | null = null;
  private lastCacheUpdate = 0;
  private readonly CACHE_DURATION = 5000; // 5 seconds cache

  private getCustomersMap(): Map<any, any> {
    const now = Date.now();
    if (
      !this.customersMapCache ||
      now - this.lastCacheUpdate > this.CACHE_DURATION
    ) {
      const customersArray = this._dataService.customers();
      this.customersMapCache = new Map(
        customersArray.map((c: any) => [c.id, c])
      );
      this.lastCacheUpdate = now;
    }
    return this.customersMapCache;
  }

  private getMaterialsMap(): Map<any, any> {
    const now = Date.now();
    if (
      !this.materialsMapCache ||
      now - this.lastCacheUpdate > this.CACHE_DURATION
    ) {
      const materialsArray = this._dataService.materials();
      this.materialsMapCache = new Map(
        materialsArray.map((m: any) => [m.id, m])
      );
      this.lastCacheUpdate = now;
    }
    return this.materialsMapCache;
  }

  getStockTableData(): Observable<any[]> {
    const localData = this._dataService.getLS("stockTableData") || [];
    const localObservable = of(localData);

    let start: number = 0;

    const liveQueryObservable = combineLatest([
      this._dataService.dateChanged,
      this._selectedStockGroupId$.pipe(distinctUntilChanged()),
      this._dbUpdating$.pipe(distinctUntilChanged()),
    ]).pipe(
      tap(() => {
        start = performance.now();
        this.dataLoading.set(true);
      }),
      switchMap(([dateChanged, stockGroupId, dbUpdating]) => {
        // Use cached maps
        const customersMap = this.getCustomersMap();
        const materialsMap = this.getMaterialsMap();

        const startDateValue = this._dataService.startDate?.value;
        const endDateValue = this._dataService.endDate?.value;

        const startDate = startDateValue
          ? startDateValue.format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD");
        const endDate = endDateValue
          ? endDateValue.format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD");

        return from(
          liveQuery(() =>
            this.getDxTransactions(startDate, endDate, stockGroupId)
          )
        ).pipe(
          map((things: any[]) => {
            const groupedThings: { [key: string]: any } = {};

            // Single pass grouping with optimized lookups
            for (const thing of things) {
              const key = thing.transactionId.id;
              const customer = customersMap.get(thing.customerId);
              const material = materialsMap.get(thing.materialId);

              const itemSum = parseFloat(
                (thing.quantity * thing.price).toFixed(3)
              );

              if (!groupedThings[key]) {
                groupedThings[key] = {
                  ...thing,
                  customerName:
                    customer?.name ||
                    (thing.customerId === 0 ? "Pərakəndə" : ""),
                  materialName: material?.name || "",
                  unit: material?.unit,
                  sum: itemSum,
                  dateAdded: thing.transactionId.dateAdded,
                  details: thing.transactionId.details,
                };
              } else {
                // Accumulate for existing group
                const currentMaterialName =
                  material?.name || "Unknown Material";
                groupedThings[key].materialName += ", " + currentMaterialName;
                groupedThings[key].sum += itemSum;
                groupedThings[key].quantity = null;
                groupedThings[key].price = null;
              }
            }

            return Object.values(groupedThings);
          }),
          map((data: { sum: number; [key: string]: any }[]) => {
            // Single pass total calculation
            let newTotalIn = 0;
            let newTotalOut = 0;

            for (const item of data) {
              const sumValue = typeof item.sum === "number" ? item.sum : 0;
              if (sumValue > 0) {
                newTotalIn += sumValue;
              } else if (sumValue < 0) {
                newTotalOut += sumValue;
              }
              // Note: sumValue === 0 is excluded from both totals (unlike original)
            }

            this.totalIn = newTotalIn;
            this.totalOut = newTotalOut;
            this.performance = performance.now() - start;

            // Batch localStorage updates
            this._dataService.setLS("stockTableData", data.slice(-100));
            this._dataService.setLS("stockTotalIn", this.totalIn);
            this._dataService.setLS("stockTotalOut", this.totalOut);

            return data;
          }),
          tap(() => {
            // Use requestAnimationFrame instead of setTimeout for better performance
            requestAnimationFrame(() => {
              this.dataLoading.set(false);
              if (this.searchInput?.nativeElement.value) {
                this.applyFilter(this.searchInput.nativeElement.value);
              }
            });
          })
        );
      }),
      takeUntil(this.componentDestroyed$)
    );

    return merge(localObservable, liveQueryObservable);
  }

  async getDxTransactions(
    startDate: string,
    endDate: string,
    stockGroupId?: any
  ): Promise<any[]> {
    // Parallel database queries
    const [transactionsFromDb, stockCards] = await Promise.all([
      db.stock.where("date").between(startDate, endDate, true, true).toArray(),
      this.showSummary
        ? this._stockService.getStockCards(startDate, endDate, stockGroupId)
        : Promise.resolve([]),
    ]);

    // Single filter operation
    const result = transactionsFromDb.filter(
      (t: any) => t.stockGroupId == stockGroupId && t.tType != "Production"
    );

    if (this.showSummary) {
      if (stockCards.length > 0) {
        this.stockGraphs = stockCards;
        this.stockGraphsUnfiltered = stockCards;
      } else {
        this.stockGraphs = [];
        this.stockGraphsUnfiltered = [];
      }

      // Optimized: Use the consistent getMaterialTotalsOptimized for the total remaining value
      // This ensures it matches the Material Component and Dashboard
      const endDateValue = this._dataService.endDate?.value;
      const endDate = endDateValue
        ? endDateValue.format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");

      const mTotals = await this._stockService.getMaterialTotalsOptimized(
        endDate,
        stockGroupId
      );

      // Use Math.max(0, ...) to only include positive values (same as Materials Component and Dashboard)
      // This ensures consistent totals across all components
      this.totalRemaining = mTotals.reduce((sum, m) => sum + Math.max(0, m.totalPrice || 0), 0);

      this._dataService.setLS("stockTotalRemaining", this.totalRemaining);
    } else {
      this.stockGraphs = [];
    }

    return result;
  }

  // Optimized getStockCards with reduced redundancy
  async getStockCards(startDate: string, endDate: string, stockGroupId?: any) {
    type ProductTotal = {
      materialId: number;
      materialName: string;
      totalQuantity?: number;
      totalPrice?: number;
      unit?: string;
      unitPrice?: number;
      sumBetweenDates?: number;
      sumBeforeStartDate?: number;
      totalQuantityBeforeDate?: number;
      sells?: number;
      stockInPrice?: number;
      stockOutPrice?: number;
      stockInQuantity: number;
      stockOutQuantity: number;
      stockInBeforeQuantity?: number;
      stockInBeforePrice?: number;
      stockOutBeforeQuantity?: number;
      stockOutBeforePrice?: number;
      averagePrice?: number;
      [key: string]: any;
    };

    // Parallel database queries
    const [stocks, stocksBefore, sells, sellsBefore] = await Promise.all([
      db.stock.where("date").between(startDate, endDate, true, true).toArray(),
      db.stock.where("date").below(startDate).toArray(),
      db.sells.where("date").between(startDate, endDate, true, true).toArray(),
      db.sells
        .where("date")
        .below(startDate)
        .toArray()
        .then((transactions) =>
          transactions.filter((t) => t.materialId !== null)
        ),
    ]);

    // Apply stockGroupId filter if specified (single pass each)
    const filterByStockGroup = (items: any[]) =>
      stockGroupId
        ? items.filter((t) => t.stockGroupId == stockGroupId)
        : items;

    const [filteredStocks, filteredStocksBefore, filteredSells] = [
      filterByStockGroup(stocks),
      filterByStockGroup(stocksBefore),
      filterByStockGroup(sells),
    ];

    const materialsMap = this.getMaterialsMap();
    const productTotals: { [key: string]: ProductTotal } = {};

    // Helper function to get or create material entry
    const getOrCreateMaterial = (materialId: number): ProductTotal => {
      if (!productTotals[materialId]) {
        const material = materialsMap.get(materialId);
        productTotals[materialId] = {
          materialId,
          materialName: material?.name || null,
          unit: material?.unit || null,
          unitPrice: material?.price || null,
          sumBetweenDates: 0,
          sumBeforeStartDate: 0,
          totalPrice: 0,
          totalQuantity: 0,
          totalQuantityBeforeDate: 0,
          sells: 0,
          stockInPrice: 0,
          stockOutPrice: 0,
          stockInQuantity: 0,
          stockOutQuantity: 0,
          stockInBeforeQuantity: 0,
          stockOutBeforeQuantity: 0,
          stockInBeforePrice: 0,
          stockOutBeforePrice: 0,
        };
      }
      return productTotals[materialId];
    };

    // Process current period stocks
    for (const stock of filteredStocks) {
      const { materialId, quantity, price, tType } = stock;
      const materialTotal = quantity * price;
      const material = getOrCreateMaterial(materialId);

      material.sumBetweenDates += materialTotal;
      material.totalPrice += materialTotal;
      material.totalQuantity += quantity;

      if (tType === "Stock Entry") {
        material.stockInQuantity += quantity;
        material.stockInPrice += materialTotal;
      } else if (tType === "Stock Out" || tType === "Production") {
        material.stockOutQuantity -= quantity;
        material.stockOutPrice -= materialTotal;
      }
    }

    // Process stocks before period
    for (const stock of filteredStocksBefore) {
      const { materialId, quantity, price, tType } = stock;
      const materialTotal = quantity * price;
      const material = getOrCreateMaterial(materialId);

      material.sumBeforeStartDate += materialTotal;
      material.totalPrice += materialTotal;
      material.totalQuantityBeforeDate += quantity;

      if (tType === "Stock Entry") {
        material.stockInBeforeQuantity += quantity;
        material.stockInBeforePrice += materialTotal;
      } else if (tType === "Stock Out") {
        material.stockOutBeforeQuantity += quantity;
        material.stockOutBeforePrice += materialTotal;
      }
    }

    // Process current sells
    for (const sell of filteredSells) {
      const { materialId, quantity, price } = sell;
      const material = getOrCreateMaterial(materialId);
      const sellTotal = quantity * price;

      material.totalPrice += sellTotal;
      material.totalQuantity -= quantity;
      material.stockOutQuantity += quantity;
      material.stockOutPrice += sellTotal;
    }

    // Process sells before period
    for (const sell of sellsBefore) {
      const { materialId, quantity, price } = sell;
      const material = getOrCreateMaterial(materialId);
      const sellTotal = quantity * price;

      material.stockOutBeforeQuantity -= quantity;
      material.stockOutBeforePrice -= sellTotal;
    }

    // Add initial balance for each material
    const stockGroupsToCheck = stockGroupId
      ? [stockGroupId]
      : this._dataService.stockGroups().map((sg) => sg.id);

    for (const materialId of Object.keys(productTotals).map(Number)) {
      let totalInitialBalance = 0;

      for (const sgId of stockGroupsToCheck) {
        const initialBalance = await db.initialStockBalance
          .where("[materialId+stockGroupId]")
          .equals([materialId, sgId])
          .first();

        totalInitialBalance += initialBalance?.quantity || 0;
      }

      if (totalInitialBalance !== 0) {
        const material = productTotals[materialId];
        // Add initial balance to "before start date" totals
        material.sumBeforeStartDate += totalInitialBalance;
        material.totalQuantityBeforeDate += totalInitialBalance;

        // If initial balance is positive, add to stockInBefore, else stockOutBefore
        if (totalInitialBalance > 0) {
          material.stockInBeforeQuantity += totalInitialBalance;
          material.stockInBeforePrice +=
            totalInitialBalance * (material.unitPrice || 0);
        } else {
          material.stockOutBeforeQuantity += totalInitialBalance;
          material.stockOutBeforePrice +=
            totalInitialBalance * (material.unitPrice || 0);
        }
      }
    }

    // Filter and sort results
    const result = Object.values(productTotals)
      .filter((val) => val.materialId && val.materialName)
      .sort((a, b) => (a.sumBetweenDates || 0) - (b.sumBetweenDates || 0));

    this._dataService.setLS("stocksSumData", result);
    return result;
  }

  applyFilter(val) {
    this.gridApi.setGridOption("quickFilterText", val);
    this.totalIn = 0;
    this.totalOut = 0;
    this.gridApi.forEachNodeAfterFilterAndSort((node) => {
      this.totalIn += node.data.sum > 0 ? node.data.sum : 0;
      this.totalOut += node.data.sum < 0 ? node.data.sum : 0;
    });
    this.stockGraphs = this.stockGraphsUnfiltered.filter(function (o: any) {
      return (
        latinize(o.materialName.replace(/\s/g, "").toLowerCase()).indexOf(
          latinize(val.replace(/\s/g, "").toLowerCase())
        ) > -1
      );
    });
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridApi.setGridOption("includeHiddenColumnsInQuickFilter", true);
    var defaultSortModel: ColumnState[] = [
      { colId: "date", sort: "asc", sortIndex: 0 },
    ];
    params.api.applyColumnState({ state: defaultSortModel });
  }

  async openAddStockDialog(
    data?,
    stockEntryType?: string,
    event?,
    editMode?: boolean,
    copyMode?: boolean
  ) {
    if ((event && event.event.target.innerText != "more_horiz") || !event) {
      this._dataService.showContextMenu = false;
      let transactions = null;
      if (data?.tId) {
        transactions = await db.stock.where("tId").equals(data.tId).toArray();
        data.editMode = editMode;
        data.copyMode = copyMode;
      }
      if (stockEntryType == "Stock Transfer" || data?.tType == "Stock Transfer") {
        this.openStockTransferDialog(data);
        return;
      }
      if (stockEntryType == "Reconciliation" || data?.tType == "Reconciliation") {
        // Map stock entry to transaction-like object for DataService
        const transaction = {
          id: data.tId,
          type: "Reconciliation",
          details: data.details,
          date: data.date
        };
        this._dataService.transactionDialog(transaction);
        return;
      }
      this.dialog.open(AddStockDialogComponent, {
        width: "1000px",
        data: {
          data,
          stockEntryType,
          stockGroupId: this.selectedStockGroupId(),
          transactions,
        },
        panelClass: "materialDialog",
        closeOnNavigation: true,
        disableClose: this._dataService.mobileDevice
          ? false
          : editMode || copyMode || !data?.tId
          ? true
          : false,
      });
    }
  }

  openStockTransferDialog(data?) {
    let dialogData = {
      selectedStockGroupId: this.selectedStockGroupId(),
      data: data ? data : null,
    };
    const dialogRef = this.dialog.open(StockTransferComponent, {
      width: "700px",
      maxHeight: "700px",
      data: dialogData,
      panelClass: "materialDialog",
      closeOnNavigation: true,
      disableClose: this._dataService.mobileDevice
        ? false
        : data
        ? false
        : true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      // this.getDxData();
      if (res) {
        this._syncService.syncDB();
        // console.log(res);
        // db.bank.add(res, res.id);
      }
    });
  }

   openReconTransferDialog(data?) {
    let dialogData = {
      mode: 'bulk'
    };
    const dialogRef = this.dialog.open(ReconciliationDialogComponent, {
      width: "700px",
      maxHeight: "700px",
      data: dialogData,
      panelClass: "materialDialog",
      closeOnNavigation: true,
      disableClose: this._dataService.mobileDevice
        ? false
        : data
        ? false
        : true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      // this.getDxData();
      if (res) {
        this._syncService.syncDB();
        // console.log(res);
        // db.bank.add(res, res.id);
      }
    });
  }

  materialDetailsDialog(materialId) {
    let dialogRef, data;
    if (materialId) {
      data = this.materials.find((x) => x.id == materialId);
    }
    dialogRef = this.dialog.open(NewMaterialDialogComponent, {
      width: "750px",
      data: data,
      panelClass: "materialDialog",
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        if (res?.id) {
          _.set(_.find(this.materials, { id: res.id }), "name", res.name);
          _.set(_.find(this.materials, { id: res.id }), "unit", res.unit);
          _.set(_.find(this.materials, { id: res.id }), "price", res.price);
          _.set(_.find(this.groupSumData, { id: res.id }), "name", res.name);
          _.set(_.find(this.groupSumData, { id: res.id }), "unit", res.unit);
        } else {
          this.materials = [...this.materials, res];
        }
        localStorage.setItem("groupSumData", JSON.stringify(this.groupSumData));
        localStorage.setItem("materials", JSON.stringify(this.materials));
      }
    });
  }

  onWheel(event: WheelEvent): void {
    if (
      !this.cardsContainer?.nativeElement?.className?.includes("expandedGraphs")
    ) {
      // Check if the event is triggered by a mouse wheel
      if (event.deltaMode === WheelEvent.DOM_DELTA_PIXEL) {
        this.cardsContainer.nativeElement.scrollLeft += event.deltaY;
        // event.preventDefault();
      }
    }
  }

  onCellMouseOver(params) {
    if (!this._dataService.showContextMenu)
      this.contextMenuData.data = params.data;
    this.hoverData = params.data;
  }

  onRightClick(event?) {
    event.preventDefault();
    if (this.contextMenuData.data != this.hoverData) {
      this.contextMenuData.data = this.hoverData;
    }
    const targetElement = event.target as HTMLElement;
    const rect = targetElement.getBoundingClientRect();

    this.contextMenuData.x = event.clientX;
    this.contextMenuData.y = rect.bottom + window.scrollY;

    this._dataService.showContextMenu = true;
  }

  contextMenu(data) {
    let lastOpened = this.contextMenuData.data
      ? this.contextMenuData.data.id
      : null;
    data.event.preventDefault();
    const targetElement = data.event.target as HTMLElement;
    const rect = targetElement.getBoundingClientRect();

    this.contextMenuData = {
      x: null,
      y: rect.bottom + window.scrollY,
      data: data.data,
    };
    this._dataService.showContextMenu =
      lastOpened == this.contextMenuData.data.id
        ? !this._dataService.showContextMenu
        : true;
  }

  async deleteEntry(row) {
    this._dataService.showContextMenu = false;
    let data = "";
    await db.stock
      .where("tId")
      .equals(row.tId)
      .toArray()
      .then((res) => {
        console.log(res);
        res.forEach((st) => {
          let materialName = this._dataService
            .materials()
            .filter((x) => x.id == st.materialId)[0].name;
          data += `${materialName} , ${st.quantity} əd \n `;
        });
      });
    data = data.substring(0, data.length - 3);

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "500px",
      data: data,
      closeOnNavigation: true,
    });
    dialogRef.afterClosed().subscribe(async (res) => {
      if (res) {
        try {
          const registration = await navigator.serviceWorker.ready;
          await (registration as any).sync.register("test-sync");

          const payload = {
            type: "REMOVE_TRANSACTION",
            removeTransactionId: row.tId,
            dbName: this._dataService.dbTable,
            userId: this._dataService.userId,
          };

          await qService.requests.add({
            payload,
            timestamp: Date.now(),
          });

          await (registration as any).sync.register("app-sync");

          await db.transactions.delete(row.tId);
          await db.stock.where("tId").equals(row.tId).delete();
        } catch {
          this.http
            .put(
              this._dataService.dbBase +
                "api.php/records/transactions/" +
                row.tId,
              { status: 1, userId: this._dataService.userId }
            )
            .subscribe(async () => {
              await db.transactions.delete(row.tId);
              await db.stock.where("tId").equals(row.tId).delete();
              this._pusher.postData("Stock Entry Deleted").subscribe();
              this.toastr.success("", "Silindi!", {
                toastClass: "ngx-toastr customToast",
                progressBar: true,
                timeOut: 2500,
                progressAnimation: "increasing",
              });
              setTimeout(() => {
                // this.dataLoading = false;
                // this.loadingProgress = 0;
              }, 700);
            });
        }
      }
    });
  }
}
